import { FC } from 'react';

import { Career } from 'libs/http/api/content/content.types';

import { CareerCard } from 'features/about/atoms/CareerCard/CareerCard';

import styles from './CareerCategory.module.scss';

type Props = {
  title: string;
  key: string;
  data: Career[];
};

export const CareerCategory: FC<Props> = ({ title, key, data }) => {
  if (data.length > 0) {
    return (
      <div className={styles['category-wrapper']} key={key}>
        <div className={styles['category-header']}>
          <h4>{title}</h4>
          <span className={styles['category-count']}>
            {data.length} {data.length === 1 ? 'open role' : 'open roles'}
          </span>
        </div>

        {data.map((career, index) => (
          <CareerCard
            key={career.name}
            name={career.name}
            category={title}
            location={career.location}
            slug={career.slug}
            index={index}
          />
        ))}
      </div>
    );
  }

  return null;
};
